// Shared membership-category metadata (web).
export const MEMBER_CATEGORIES = {
  founding_member: {
    label: "Founding Member",
    short: "Founding",
    badgeClass: "border-primary/50 bg-zinc-800 text-zinc-300",
  },
  sim_racing_expert: {
    label: "Sim Racing Expert",
    short: "Expert",
    badgeClass: "border-sky-400/40 bg-sky-400/15 text-sky-300",
  },
  content_creator: {
    label: "Content Creator",
    short: "Creator",
    badgeClass: "border-fuchsia-400/40 bg-fuchsia-400/15 text-fuchsia-300",
  },
};

export const memberCategoryLabel = (key) => MEMBER_CATEGORIES[key]?.label || "";
export const memberCategoryBadgeClass = (key) =>
  MEMBER_CATEGORIES[key]?.badgeClass || "border-border bg-secondary text-muted-foreground";
